export const HLS_X_MPEGURL = 'application/x-mpegURL'
export const HLS_VND_APPLE = 'application/vnd.apple.mpegurl'

export const isHLS = (mime) => mime === HLS_X_MPEGURL || mime === HLS_VND_APPLE
